import React from "react";
import AppcheckBase from "@src/layouts/AppcheckBase";

function Appcheck() {
  return (
    <AppcheckBase>
      <a
        id="app-trigger"
        href="https://teach.classdojo.com"
        data-app="https://teach.classdojo.com"
        data-app-ios="https://www.classdojo.com/ul/t/home"
        data-app-android="https://www.classdojo.com/ul/t/home"
        data-store-android="com.classdojo.android"
        data-store-ios="552602056"
        style={{ color: "#fff" }}
      >
        ClassDojo App
      </a>
    </AppcheckBase>
  );
}

export default Appcheck;
